import React, { useState, useEffect, useRef } from "react";
import "./FeaturesCarousel.css";

import Dashboard1 from "../../assets/Features/Dashboard1.png";
import Dashboard2 from "../../assets/Features/Dashboard2.png";
import Dashboard3 from "../../assets/Features/Dashboard3.png";

const slides = [
    {
        title: "LinkedIn Post Generator",
        description: "Choose Your Favorite Creators For Inspiration And Craft Posts That Stand Out.",
        image: Dashboard1,
        upcoming: false,
    },
    {
        title: "LinkedIn Post Scheduler",
        description: "Plan, Optimize, And Automate Your LinkedIn Posts For Maximum Impact At The Perfect Time.",
        image: Dashboard2,
        upcoming: true,
    },
    {
        title: "LinkedIn Profile Analytics",
        description: "Track Your Performance, Understand Your Audience, And Grow Smarter Every Day.",
        image: Dashboard3,
        upcoming: true,
    },
];

export default function FeaturesCarousel() {
    const [active, setActive] = useState(0);
    const [fade, setFade] = useState(false);
    const intervalRef = useRef(null);

    const handleStepClick = (index) => {
        setFade(true);
        setTimeout(() => {
            setActive(index);
            setFade(false);
        }, 300); // duration of fade-out
        resetAutoplay();
    };

    const resetAutoplay = () => {
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(() => {
            nextSlide();
        }, 2000);
    };

    const nextSlide = () => {
        setFade(true);
        setTimeout(() => {
            setActive((prev) => (prev + 1) % slides.length);
            setFade(false);
        }, 300);
    };

    useEffect(() => {
        intervalRef.current = setInterval(nextSlide, 2000);
        return () => clearInterval(intervalRef.current);
    }, []);

    // 🔑 Preload images once so they are cached
    useEffect(() => {
        slides.forEach((slide) => {
            const img = new Image();
            img.src = slide.image;
        });
    }, []);

    return (
        <section className="carousel-section">
            <h2 className="carousel-heading">
                Features <span className="brandly-black">By Brandly</span>
            </h2>

            <div className="carousel-outer">
                <div className="carousel-inner">
                    <div className="carousel-box">
                        {/* Left */}
                        <div className="carousel-left">
                            <div className="carousel-steps">
                                {[1, 2, 3].map((num, index) => (
                                    <div
                                        key={index}
                                        className={`carousel-step ${active === index ? "active" : ""}`}
                                        onClick={() => handleStepClick(index)}
                                    >
                                        {num}
                                    </div>
                                ))}
                            </div>
                            <h3 className="carousel-title">{slides[active].title}</h3>
                            <p className="carousel-desc">{slides[active].description}</p>
                            {slides[active].upcoming && (
                                <p className="upcoming">(UPCOMING)</p>
                            )}
                        </div>

                        {/* Right */}
                        <div className="carousel-right">
                            <img
                                src={slides[active].image}
                                alt="Feature Preview"
                                className={`carousel-img ${fade ? "fade-out" : "fade-in"}`}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
